import AuthService from '../oauth/services/AuthService';
import {
  setIsUnderMaintenance,
  setIsUnderMaintenanceMessage,
} from '../store/actions';
import {Store} from './../store';
import {uriGetBus} from './endpoints';

const tenantAlias = process.env.REACT_APP_DEFAULT_TENANT_ALIAS;
const maintenanceApi = process.env.REACT_APP_BASE_API_MAINTENANCE;

const configs = (info?: boolean, feature?: string) => {
  const authorizationHeaders: any = {};
  const state = Store.getState();
  const localStorageUser = JSON.parse(localStorage?.getItem('user') as string);

  const token =
    localStorage?.getItem('access_token') ||
    localStorageUser?.access_token ||
    state?.accessToken?.value;
  if (!!token) {
    authorizationHeaders.authorization = `Bearer ${token}`;
  }

  return {
    headers: {
      'Content-Type': 'application/json',
      Accept: '*/*',
      X_MYADV_API_KEY: tenantAlias,
      ...authorizationHeaders,
      ...(info
        ? {
            advSource: 'WebPortal',
            advBu: state.selectedBu.value.buId,
            advMemId: state.selectedBu.value.memId,
          }
        : null),
      ...(feature ? {feature: feature} : null),
    },
  };
};

const getDefaultHeaders = (feature?: string) => {
  const state = Store.getState();
  return {
    ...configs().headers,
    advSource: 'WebPortal',
    advBu: state.selectedBu.value.buId || state?.tenant?.value?.buDefaultAlias,
    advMemId: state.selectedBu.value.memId,
    X_MYADV_API_KEY: tenantAlias,
    'Accept-Language':
      (state.user.value === null
        ? state.language.value
        : state.user.value.language || state.language?.value) ||
      state?.stringsDefault?.value?.pt?.messages?.default_language,
    ...(feature ? {feature: feature} : null),
  };
};

export const configsNoContentType = (feature?: string) => {
  const authorizationHeaders: any = {};
  const state = Store.getState();
  const localStorageUser = JSON.parse(localStorage?.getItem('user') as string);

  const token =
    localStorage?.getItem('access_token') ||
    localStorageUser?.access_token ||
    state?.accessToken?.value;
  if (!!token) {
    authorizationHeaders.authorization = `Bearer ${token}`;
  }

  return {
    headers: {
      advSource: 'WebPortal',
      advBu:
        state.selectedBu.value.buId || state?.tenant?.value?.buDefaultAlias,
      advMemId: state.selectedBu.value.memId,
      X_MYADV_API_KEY: tenantAlias,
      Accept: '*/*',
      'Accept-Language':
        (state.user.value === null
          ? state.language.value
          : state.user.value.language || state.language?.value) ||
        state?.stringsDefault?.value?.pt?.messages?.default_language,
      ...authorizationHeaders,
      ...(feature ? {feature: feature} : null),
    },
  };
};

export const configsAcceptLanguage = (feature?: string) => {
  const authorizationHeaders: any = {};
  const state = Store.getState();
  const localStorageUser = JSON.parse(localStorage?.getItem('user') as string);

  const token =
    localStorage?.getItem('access_token') ||
    localStorageUser?.access_token ||
    state?.accessToken?.value;
  if (!!token) {
    authorizationHeaders.authorization = `Bearer ${token}`;
  }

  return {
    headers: {
      advSource: 'WebPortal',
      advBu:
        state.selectedBu.value.buId || state?.tenant?.value?.buDefaultAlias,
      advMemId: state.selectedBu.value.memId,
      X_MYADV_API_KEY: tenantAlias,
      Accept: '*/*',
      ...authorizationHeaders,
      'Accept-Language':
        state.user.value === null
          ? state.language.value
          : state.user.value.language ||
            state.language?.value ||
            state?.stringsDefault?.value?.pt?.messages?.default_language,
      ...(feature ? {feature: feature} : null),
    },
  };
};

export const isValidSession = () => {
  const state = Store.getState();
  const localStorageUser = JSON.parse(localStorage.getItem('user') as string);

  const token =
    localStorage?.getItem('access_token') ||
    localStorageUser?.access_token ||
    state?.accessToken?.value;
  return !!token;
};

export const clearAuthToken = (setClearedFlag: boolean = false) => {
  if (localStorage.getItem('logged_in_by_url') === 'false') {
    if (isValidSession()) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('expires_in');
    } else {
      if (setClearedFlag) {
        localStorage.setItem('cleared', 'true');
        window.location.reload();
      }
    }
  }
};

const handleError = async (res: Response) => {
  let errorData = null;
  try {
    const contentType = res.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
      errorData = await res.json();
    } else {
      errorData = await res.text();
    }
  } catch (e) {
    errorData = {message: 'Erro ao ler resposta de erro'};
  }

  return {
    status: res.status,
    data: errorData,
  };
};

export const get = (
  url: string,
  isRetry = false,
  numberOfTries = 0,
  feature?: string
) =>
  new Promise((resolve, reject) => {
    fetch(url, {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      headers: getDefaultHeaders(feature),
    }).then(async (res: any) => {
      Store.dispatch(
        setIsUnderMaintenance(
          res.status === 508 && url?.includes(maintenanceApi || '')
        )
      );
      if (res.status < 400) {
        res.json().then((json: any) => {
          resolve(JSON.parse(JSON.stringify(json)));
        });
      } else if (url === uriGetBus()) {
        if (numberOfTries < 4) {
          get(url, false, numberOfTries + 1, feature);
        } else {
          const as = new AuthService();
          as.logout();
        }
      } else {
        if (res.status === 401) {
          if (!isRetry) {
            get(url, true);
          } else {
            clearAuthToken(true);
          }
        } else {
          reject(await handleError(res));
        }
      }
    });
  });

export const getWithCustomHeaders = (
  url: string,
  customHeaders: any,
  isRetry = false,
  isRedeMedica = false,
  settingError?: {(error: boolean): void; (arg0: boolean): any} | undefined,
  feature?: string
) =>
  new Promise((resolve, reject) => {
    const state = Store.getState();
    fetch(url, {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      headers: customHeaders
        ? {
            ...customHeaders,
            advSource: 'WebPortal',
            advBu:
              state.selectedBu.value.buId ||
              state?.tenant?.value?.buDefaultAlias,
            advMemId: state.selectedBu.value.memId,
            X_MYADV_API_KEY: tenantAlias,
            'Accept-Language':
              (state.user.value === null
                ? state.language.value
                : state.user.value.language || state.language?.value) ||
              state?.stringsDefault?.value?.pt?.messages?.default_language,
            ...(feature ? {feature: feature} : null),
          }
        : getDefaultHeaders(),
    }).then(async (res: any) => {
      Store.dispatch(
        setIsUnderMaintenance(
          res.status === 508 && url?.includes(maintenanceApi || '')
        )
      );
      if (res.status < 400) {
        res.json().then((json: any) => {
          resolve(JSON.parse(JSON.stringify(json)));
        });
      } else if (res.status === 401) {
        if (!isRetry) {
          getWithCustomHeaders(
            url,
            customHeaders,
            true,
            isRedeMedica,
            settingError
          );
        } else {
          isRedeMedica
            ? settingError && settingError(true)
            : clearAuthToken(true);
        }
      } else {
        reject(await handleError(res));
      }
    });
  });

export const getBlob = (
  url: string,
  isRetry = false,
  info = false,
  feature?: string
) =>
  new Promise((resolve, reject) => {
    fetch(url, {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      ...configs(info, feature),
    }).then(async (res: any) => {
      Store.dispatch(
        setIsUnderMaintenance(
          res.status === 508 && url?.includes(maintenanceApi || '')
        )
      );
      if (res.status < 400) {
        res.blob().then((blob: any) => {
          resolve(blob);
        });
      } else if (res.status === 401) {
        if (!isRetry) {
          get(url, true);
        } else {
          clearAuthToken(true);
        }
      } else {
        reject(await handleError(res));
      }
    });
  });

export const put = (
  url: string,
  body: any,
  feature?: string,
  isRetry = false
) =>
  new Promise((resolve, reject) => {
    const state = Store.getState();
    fetch(url, {
      method: 'PUT', // *GET, POST, PUT, DELETE, etc.
      headers: getDefaultHeaders(feature),
      body: JSON.stringify(body),
    }).then(async (res: any) => {
      Store.dispatch(
        setIsUnderMaintenance(
          res.status === 508 && url?.includes(maintenanceApi || '')
        )
      );
      if (res.status < 400) {
        res.json().then((json: any) => {
          resolve(JSON.parse(JSON.stringify(json)));
        });
      } else if (res.status === 401) {
        if (!isRetry) {
          put(url, body, feature, true);
        } else {
          clearAuthToken(true);
        }
      } else {
        reject(await handleError(res));
      }
    });
  });

export const patch = (
  url: string,
  body: any,
  feature?: string,
  isRetry = false
) =>
  new Promise((resolve, reject) => {
    const state = Store.getState();
    fetch(url, {
      method: 'PATCH', // *GET, POST, PUT, DELETE, etc.
      headers: getDefaultHeaders(feature),
      body: JSON.stringify(body),
    }).then(async (res: any) => {
      Store.dispatch(
        setIsUnderMaintenance(
          res.status === 508 && url?.includes(maintenanceApi || '')
        )
      );
      if (res.status < 400) {
        res.json().then((json: any) => {
          resolve(JSON.parse(JSON.stringify(json)));
        });
      } else if (res.status === 401) {
        if (!isRetry) {
          patch(url, body, feature, true);
        } else {
          clearAuthToken(true);
        }
      } else {
        reject(await handleError(res));
      }
    });
  });

//TODO: Update call
export const post = (url: any, body: any, isRetry = false, feature?: string) =>
  new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      headers: getDefaultHeaders(feature),
      body: JSON.parse(JSON.stringify(body)),
    }).then(async (res: any) => {
      Store.dispatch(
        setIsUnderMaintenance(
          res.status === 508 && url?.includes(maintenanceApi || '')
        )
      );
      if (res.status < 400) {
        res.json().then((json: any) => {
          resolve(JSON.parse(JSON.stringify(json)));
        });
      } else if (res.status === 401) {
        if (!isRetry) {
          post(url, body, true);
        } else {
          clearAuthToken(true);
        }
      } else {
        reject(await handleError(res));
      }
    });
  });

export const postWithoutBody = (url: any, isRetry = false, feature?: string) =>
  new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      headers: getDefaultHeaders(feature),
    }).then(async (res: any) => {
      Store.dispatch(
        setIsUnderMaintenance(
          res.status === 508 && url?.includes(maintenanceApi || '')
        )
      );
      if (res.status < 400) {
        res.json().then((json: any) => {
          resolve(JSON.parse(JSON.stringify(json)));
        });
      } else if (res.status === 401) {
        if (!isRetry) {
          post(url, true);
        } else {
          clearAuthToken(true);
        }
      } else {
        reject(await handleError(res));
      }
    });
  });

export const postWithCustomHeaders = (
  url: any,
  body: any,
  headers = configsNoContentType(),
  isRetry = false,
  timeOut = '29'
) =>
  new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      ...headers,
      body: body,
      //signal: AbortSignal.timeout(parseInt(timeOut, 10) * 1000)
    })
      .then(async (res: any) => {
        Store.dispatch(
          setIsUnderMaintenance(
            res.status === 508 && url?.includes(maintenanceApi || '')
          )
        );
        if (res.status < 400) {
          res.json().then((json: any) => {
            resolve(JSON.parse(JSON.stringify(json)));
          });
        } else if (res.status === 401) {
          if (!isRetry) {
            postWithCustomHeaders(url, body, headers, true);
          } else {
            clearAuthToken(true);
          }
        } else {
          if (res.status === 500) {
            reject(await handleError(res));
          } else if (res.status === 401) {
            if (!isRetry) {
              postWithCustomHeaders(url, body, headers, true);
            } else {
              clearAuthToken(true);
            }
          } else {
            reject(await handleError(res));
          }
        }
      })
      .catch(async (error) => {
        reject(await handleError(error));
      });
  });

//TODO: Update call
export const remove = (url: string, feature?: string, isRetry = false) =>
  new Promise((resolve, reject) => {
    const state = Store.getState();
    fetch(url, {
      method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
      headers: getDefaultHeaders(feature),
    }).then(async (res) => {
      if (res.status < 400) {
        resolve(res);
      } else {
        if (res.status === 401) {
          if (!isRetry) {
            get(url, true);
          } else {
            clearAuthToken(true);
          }
        } else {
          reject(await handleError(res));
        }
      }
    });
  });

export default {
  get,
  getWithCustomHeaders,
  put,
  post,
  postWithCustomHeaders,
  remove,
};
